<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button v-if="is_allowed_delete" :disabled="!showActionDelete" v-on:click="showConfirmationModal = true"
              class="btn btn-danger">
              <i class="fa fa-trash"></i> Delete
            </button>
            <button v-on:click="onEditRow" :disabled="!showActionEdit" class="btn btn-primary">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewData" class="btn btn-primary">
              Create
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                Brand Code
              </label>
              <div class="col-8">
                <model-list-select :list="brandCodeOption" v-model="BrandCodeModel" option-value="value"
                  option-text="text" placeholder="select merchant item">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true" @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert :type="deleteMessages[0].type" :dismissible="true" v-for="(row, index) in deleteMessages"
            :key="index">{{ row.message }}</base-alert>
        </div>
        <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes"
          @on-select-row="onSelectRow" @on-unselect-row="onSelectRow" @refresh-data="onRefreshData(BrandCodeModel)">
          <template slot="default_rule_column" slot-scope="props">
            <label v-if="props.cell_value == 0"> False </label>
            <label v-if="props.cell_value == 1"> True </label>
          </template>
          <template slot="is_slice_free_spin_column" slot-scope="props">
            <label v-if="props.cell_value == 0"> False </label>
            <label v-if="props.cell_value == 1"> True </label>
          </template>
          <template slot="is_slice_try_again_column" slot-scope="props">
            <label v-if="props.cell_value == 0"> False </label>
            <label v-if="props.cell_value == 1"> True </label>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.raffleName }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button type="link" class="ml-auto btn-block" @click="showConfirmationModal = false">No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button type="primary" class="ml-auto btn-block" @click="onDeleteRow">Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <div v-if="message">
        <base-alert :type="message.type" :dismissible="true" @resetMessage="resetMessage">{{
          message.message
        }}</base-alert>
      </div>
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Raffle Event
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group has-label">
              <label class="form-control-label">
                Brand Code<span>*</span>
              </label>
              <model-list-select :list="brandCodeOption" v-model="BrandCodeModel" option-value="value"
                option-text="text" placeholder="select Brand" :isDisabled="isBrandCodeDisabled || disableAllFields">
              </model-list-select>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group has-label">
              <label class="form-control-label">
                Raffle Type
              </label>
              <model-list-select v-model="RaffleEventTypeModel" :list="raffleTypeOptions" option-value="value"
                option-text="text" class="mx-input" placeholder="Select Raffle Type"
                :isDisabled="disableAllFields"></model-list-select>
            </div>
          </div>
          <div class="col-lg-4">
            <base-input alternative="" label="Raffle Event Name*" input-classes="form-control"
              v-model="raffleEventModel.raffleName" :disabled="disableAllFields" />
          </div>
          <div class="col-lg-4" v-if="isSkuShow">
            <base-input alternative="" label="SKU" input-classes="form-control" v-model="SkuModel"
              :disabled="disableAllFields" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4" v-if="isPromoShow">
            <div class="form-group has-label">
              <label class="form-control-label">
                Promo
              </label>
              <multiselect v-model="PromoModel" placeholder="Search Promo" label="promotion_name" track-by="id"
                :options="promoOptions" :multiple="false" :taggable="false" :searchable="true"
                :disabled="disableAllFields" @search-change="onSearchPromo">
              </multiselect>
            </div>
          </div>
          <div class="col-lg-4" v-if="isDeductionAmountShow">
            <base-input alternative="" label="Deduction Amount" input-classes="form-control"
              v-model="raffleEventModel.deductionAmount" type="number" :disabled="disableAllFields" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group has-label">
              <label class="form-control-label"> Raffle Date <span>*</span></label>
              <date-picker v-model="raffleEventModel.raffleDate" editable clearable value-type="YYYY-MM-DD"
                id="RaffleDate" :default-value="raffleEventModel.raffleDate" :disabled="disableAllFields"
                style="width: 100%" required></date-picker>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="form-group has-label">
              <label class="form-control-label"> Start End Date * </label>
              <date-picker v-model="startEndDate" range editable value-type="YYYY-MM-DD" id="StartEndDate"
                :default-value="startEndDate" :disabled="disableAllFields" style="width: 100%"></date-picker>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12">
            <label class=" col-form-label form-control-label">
              Region<span>*</span>
            </label>
            <div class="">
              <b-form-select id="input-region" v-model="RegionModel" :default-value="RegionModel"
                :options="regionOption" :disabled="disableAllFields" class="mx-input"></b-form-select>
            </div>
          </div>
          <div class="col-lg-12">
            <label class=" col-form-label form-control-label">
              Province<span>*</span>
            </label>
            <div class="">
              <b-form-select id="input-province" v-model="ProvinceModel" :default-value="ProvinceModel"
                :options="provinceOption" :disabled="disableAllFields" class="mx-input"></b-form-select>
            </div>
          </div>
          <div class="col-lg-12">
            <label class=" col-form-label form-control-label">
              City<span>*</span>
            </label>
            <div class="">
              <b-form-select id="input-city" v-model="CityModel" :default-value="CityModel" :options="cityOption"
                :disabled="disableAllFields" class="mx-input"></b-form-select>
            </div>
          </div>
          <button class="btn btn-primary" style="margin: 10px 15px;" @click="AddLocation()"
            :disabled="disableAllFields">Add
            Location</button>
          <table id="entriesTable" class="table">
            <thead>
              <tr>
                <th>Region</th>
                <th>Province</th>
                <th>City</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>

        </div>
        <br />
        <div class="row">
          <div class="col-lg-4">
            <base-input alternative="" label="Winners" input-classes="form-control" v-model="raffleEventModel.winners"
              :disabled="disableAllFields" required />
          </div>
          <div class="col-lg-8">
            <label class=" col-form-label form-control-label">
              Prizes
            </label>
            <div class="">
              <b-form-select v-model="MajorPrizeValue" :default-value="MajorPrizeValue" :options="MajorPrizesOption"
                :disabled="disableAllFields" class="mx-input"></b-form-select>
            </div>
          </div>
          <div v-if="message">
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-6">
            <base-input 
              id="inputEventImage" 
              label="Event Detail Image" 
              input-classes="form-control" 
              type="file"
              accept="image/*" 
              :disabled="disableAllFields" 
              @change="onEventImageChange($event)" />
            <div v-if="uploadEventImageModel.image_url">
              <img :src="uploadEventImageModel.image_url" class="img img-thumbnail" style="max-width: 200px; max-height: 200px;" />
            </div>
            <div v-else-if="raffleEventModel.eventDetailImageUrl">
              <img :src="raffleEventModel.eventDetailImageUrl" class="img img-thumbnail" style="max-width: 200px; max-height: 200px;" />
            </div>
          </div>
        </div>
        <br />
      </form>
      <template slot="footer">
        <base-button type="link" class="ml-auto" @click="showModalCreate = false">Close/ Cancel
        </base-button>
        <button v-on:click="createRaffleEvent" class="btn btn-primary" v-bind:disabled="disableButtonSubmit">
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import api_loyalty from "../api/api";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";
import "@/assets/vendor/multiselect/vue-multiselect.min.css";

export default {
  name: "RulesItemList",
  data()
  {
    return {
      isOnEditRow: false,
      is_allowed_create: false,
      BrandCodeModel: "PHFortune",
      BrandCode: "PHFortune",
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      startEndDate: [],
      RegionModel: "",
      RegionValue: [],
      ProvinceModel: "",
      ProvinceValue: [],
      CityModel: "",
      CityValue: [],
      SkuModel: "",
      PromoModel: "",
      RaffleEventTypeModel: "general",
      promoOptions: [],
      isPromoLoading: false,
      isPromoShow: false,
      isDeductionAmountShow: false,
      raffleTypeOptions: [
        { value: "general", text: "General" },
        { value: "special", text: "Special" }
      ],
      brandCodeOption: [],
      regionOption: [],
      provinceOption: [],
      cityOption: [],
      isBrandCodeDisabled: false,
      titlePopup: "Create",
      message: null,
      TimeZoneConfigValue: "",
      isSkuShow: false,
      raffleEventModel: {
        brandCode: "PHChe",
        raffleName: "",
        sku: "",
        raffleDate: new Date().toISOString(),
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
        winners: 0,
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        prizeId: "",
        prizeName: "",
        deductionAmount: 0,
        raffleType: "",
        promoId: "",
        locations: this.locationModel,
        eventDetailImageUrl: "",
      },
      uploadEventImageModel: {
        image_url: null,
        imagePresignedUrl: "",
        imageFile: null,
      },
      locationModel: {
        region: "",
        province: "",
        city: "",
      },
      lastLoginDate: new Date().toISOString(),
      MajorPrizesOption: [],
      MajorPrizeValue: "",
      showModalCreate: false,
      showModalDetail: false,
      rows: [],
      allRaffle: null,
      searchTimeout: 0,
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brandCode",
          sort: true,
        },
        {
          label: "Raffle Event Name",
          name: "raffleName",
          sort: true,
        },
        {
          label: "SKU",
          name: "sku",
          sort: true,
        },
        {
          label: "Raffle Date",
          name: "raffleDate",
          sort: true,
        },
        {
          label: "Start Date",
          name: "startDate",
          sort: true,
        },
        {
          label: "End Date",
          name: "endDate",
          sort: true,
        },
        {
          label: "Winners",
          name: "winners",
          sort: true,
        },
        {
          label: "Prize Id",
          name: "prizeId",
          sort: true,
        },
        {
          label: "Prize Name",
          name: "prizeName",
          sort: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row)
          {
            return row.id == 1;
          },
        },
      },
    };
  },
  created()
  {
    this.is_allowed_delete = this.$store.getters.isLoginUserAdmin;
    this.isBrandCodeDisabled = false;
    this.mappingRole();
    this.onRefreshData(this.BrandCodeModel);
    this.LoadTimezoneConfig();
  },
  methods: {
    mappingRole()
    {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('raffleevent')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('raffleevent')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHFortune";
      }
    },
    LoadTimezoneConfig()
    {
      api_loyalty.GetTimeZoneConfig(this.BrandCodeModel).then((data) =>
      {
        if (data.isSuccess)
        {
          this.TimeZoneConfigValue = data.data.value;
        }
      });
    },
    resetMessage()
    {
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onResetForm()
    {
      let momNow = this.$moment(new Date().toUTCString());
      let StartDate = momNow.format("YYYY-MM-DD");
      let momStart = this.$moment(new Date(StartDate)).format("YYYY-MM-DD");
      this.startEndDate = [momStart, momStart];
      this.isOnEditRow = false;
      this.isBrandCodeDisabled = false,
      this.MajorPrizeValue = "",
      this.raffleEventModel.prizes = "";
      this.BrandCodeModel;
      this.RegionModel = "";
      this.ProvinceModel = "";
      this.CityModel = "";
      this.RegionValue = [];
      this.ProvinceValue = [];
      this.CityValue = [];
      this.provinceOption = []
      this.cityOption = []
      this.PromoModel = "";
      this.RaffleEventTypeModel = "general";
      this.promoOptions = [];
      this.isSkuShow = false;
      this.raffleEventModel = {
        brandCode: this.BrandCodeModel,
        raffleName: "",
        sku: "",
        raffleDate: new Date().toISOString(),
        startDate: "",
        endDate: "",
        winners: 0,
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        prizeId: "",
        prizeName: "",
        deductionAmount: 0,
        raffleType: "",
        promoId: "",
        eventDetailImageUrl: "",
      },
      this.uploadEventImageModel = {
        image_url: "",
        imagePresignedUrl: "",
        imageFile: null,
      },
      this.ResetTable();
    },
    onCreateNewData()
    {
      this.isOnEditRow = false;
      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.isBrandCodeDisabled = false;
      this.isEdit = false;
      this.onResetForm();
      this.visibilityToggle(this.RaffleEventTypeModel);
    },
    toggleActive() { },
    async onRefreshData(brandCode)
    {
      this.fetchData(this.BrandCodeModel, this.RegionModel, this.ProvinceModel, "Region");
      api_loyalty
        .GetAllRaffleEvent(brandCode)
        .then((data) =>
        {
          try
          {
            if (data.isSuccess)
            {
              this.rows = data.data;
              this.allRaffle = data.data;
            }
          } catch (e)
          {
            console.log(e);
          }
        });
      this.onLoadPrize(brandCode);
    },
    onLoadPrize(brandCode)
    {
      api_loyalty
        .GetAllPrizesByBrandCode(brandCode)
        .then((data) =>
        {
          if(data.isSuccess){
            this.MajorPrizesOption = data.data.map(prize => ({
              value: prize.id,
              text: prize.prize_name,
              prize_name: prize.prize_name,
            }));
          }
        });
    },
    onSelectRow(payload)
    {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0)
      {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1)
      {
        this.showActionEdit = false;
      }
    },
    async onEditRow()
    {
      this.isOnEditRow = true;
      this.ResetTable();
      this.RegionModel = null;
      this.ProvinceModel = null;
      this.CityModel = null;
      this.raffleEventModel = this.allRaffle.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];

      var start_date = new Date(this.raffleEventModel.startDate);
      //ada perbedaan antara get tgl dr dynamo dan mysql.
      var hours = start_date.getHours() + parseInt(this.TimeZoneConfigValue) * 2;
      start_date.setHours(
        hours
      );
      var end_date = new Date(this.raffleEventModel.endDate);
      end_date.setHours(
        hours
      );
      var raffleDate = new Date(this.raffleEventModel.raffleDate);
      raffleDate.setHours(hours);
      this.raffleEventModel.raffleDate = raffleDate.toISOString();
      this.startEndDate = [start_date.toISOString(), end_date.toISOString()];
      this.BrandCodeModel = this.raffleEventModel.brandCode;
      this.onLoadPrize(this.BrandCodeModel);
      this.showModalCreate = true;
      this.SkuModel = this.raffleEventModel.sku;
      this.titlePopup = "Update";
      this.MajorPrizeValue = this.raffleEventModel.prizeId;
      this.RaffleEventTypeModel = this.raffleEventModel.eventType;
      this.visibilityToggle(this.RaffleEventTypeModel); 
    
      if (this.raffleEventModel.promoId) {
          await this.LoadPromo("");
          const selectedPromo = this.promoOptions.find(promo => promo.id === this.raffleEventModel.promoId);
          if (selectedPromo) {
            this.PromoModel = selectedPromo;
          }
        } else {
          this.PromoModel = "";
        }
      
      this.LoadLocations();
      this.updateDeleteLocationButtons();
    },
    onDeleteRow()
    {
      this.selectedItems.forEach((element) =>
      {
        let deleteRequest = {
          id: element.id,
        };
        this.raffleEventModel.id = deleteRequest.id;
        api_loyalty
          .DeleteRaffleEvent(this.BrandCodeModel, this.raffleEventModel)
          .then((data) =>
          {
            if(data.isSuccess)
            {
              this.onRefreshData(this.BrandCodeModel);
              let msg = {
                message:
                  "Success delete Raffle Event'" + element.raffleName + "'.",
                type: "success",
              };
              this.deleteMessages.push(msg);
            }
          })
          .catch((e) =>
          {
            console.log(e);
            var msg = {
              message:
                "Failed to delete Raffle Event '" +
                element.raffleName +
                "'.",
              type: "danger",
            };

            if (e.response && e.response.status === 401)
            {
              msg = {
                message: "You don't have a permission",
                type: 'danger'
              }
            }
            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },
    checkRaffleDates()
    {
      if (this.raffleEventModel.startDate != "" && this.raffleEventModel.endDate != "")
      {
        if (this.raffleEventModel.raffleDate < this.raffleEventModel.startDate)
        {
          this.message = {
            message: "Raffle date must be in after Start Date",
            type: "danger",
          };
          return false;
        }
        if (this.raffleEventModel.raffleDate < this.raffleEventModel.endDate)
        {
          this.message = {
            message: "Raffle date must be in after End Date",
            type: "danger",
          };
          return false;
        }
      }
      return true;
    },
    async createRaffleEvent()
    {
      if (this.startEndDate.length > 1)
      {
        let startDate = new Date(this.startEndDate[0]).toISOString() === "1970-01-01T00:00:00.000Z" ? "" : new Date(this.startEndDate[0]).toISOString();
        let endDate = new Date(this.startEndDate[1]).toISOString() === "1970-01-01T00:00:00.000Z" ? "" : new Date(this.startEndDate[1]).toISOString();
        this.raffleEventModel.startDate = startDate;
        this.raffleEventModel.endDate = endDate;
        if (!this.checkRaffleDates())
        {
          return;
        }
      } else
      {
        let minDate = new Date().toISOString();
        let maxDate = new Date(new Date().getFullYear() + 1, 11, 31).toISOString();
        this.raffleEventModel.startDate = minDate;
        this.raffleEventModel.endDate = maxDate;
      }
      // Normalize raffleDate to set time to 00:00:00.000Z
      if (this.raffleEventModel.raffleDate)
      {
        let momRaffleDate = this.$moment(this.raffleEventModel.raffleDate);
        momRaffleDate.utc().startOf('day');
        this.raffleEventModel.raffleDate = momRaffleDate.toISOString();
      }

      const selectedPrize = this.MajorPrizesOption.find(prize => prize.value === this.MajorPrizeValue);
      if (selectedPrize) {
        this.raffleEventModel.prizeId = this.MajorPrizeValue;
        this.raffleEventModel.prizeName = selectedPrize.prize_name;
      }

      this.raffleEventModel.brandCode = this.BrandCodeModel
      this.raffleEventModel.region = this.RegionValue.map(region => region.name).join(',');
      this.raffleEventModel.province = this.ProvinceValue.map(province => province.name).join(',');
      this.raffleEventModel.city = this.CityValue.map(city => city.name).join(',');
      this.raffleEventModel.sku = this.SkuModel;
      this.raffleEventModel.eventType = this.RaffleEventTypeModel;
      this.raffleEventModel.promoId = this.PromoModel ? this.PromoModel.id : "";

      // Get table data
      const tableBody = document.getElementById('entriesTable').getElementsByTagName('tbody')[0];
      const rows = Array.from(tableBody.rows);
      const locations = rows.map(row => {
        const cells = Array.from(row.cells);
        return {
          region: cells[0].textContent,
          province: cells[1].textContent,
          city: cells[2].textContent
        };
      });
     
      // Assign locations to raffleEventModel
      this.raffleEventModel.locations = locations;
      
      if (this.uploadEventImageModel.imagePresignedUrl) {
        api_loyalty.S3PutObject(
          this.uploadEventImageModel.imagePresignedUrl,
          this.uploadEventImageModel.imageFile
        );
      }
      
      if (this.raffleEventModel.id)
      {
        api_loyalty.UpdateRaffleEvent(this.BrandCodeModel, this.raffleEventModel).then((data) =>
        {
          try
          {
            if (data.isSuccess)
            {
              this.onRefreshData(this.BrandCodeModel);
              this.showModalCreate = false;
              this.ResetTable();
              this.message = {
                message: "Updated data successfully.",
                type: "success",
              };
            }
            else
            {
              this.message = {
                message: "Failed to created data.",
                type: "danger",
              };
            }
          } catch (e)
          {
            console.log(e);
            this.message = {
              message: "Failed to created data.",
              type: "danger",
            }
          }
        });
      } else
      {
        api_loyalty.CreateRaffleEvent(this.BrandCodeModel, this.raffleEventModel).then((data) =>
        {
          try
          {
            if (data.isSuccess)
            {
              this.onRefreshData(this.BrandCodeModel);
              this.showModalCreate = false;
              this.ResetTable();
              this.message =
              {
                message: "Created data successfully.",
                type: "success",
              };
            }
            else
            {
              this.message =
              {
                message: "Failed to created data.",
                type: "danger",
              };
            }
          } catch (e)
          {
            console.log(e);
            this.message = {
              message: "Failed to created data.",
              type: "danger",
            }
          }
        });
      }
    },
    async fetchData(brandCode, regionName, provinceName, action) {
      api_loyalty.GetRegionProvinceCity(brandCode, regionName, provinceName, action)
        .then((data) => {
          try {
            if(data.isSuccess){
              if (action === "Region") {
                this.regionOption = data.data;
              } else if (action === "Province") {
              if (regionName === "") {
                this.provinceOption = []
              } else {
                this.provinceOption = data.data;
              }
              } else if (action === "City") {
              if (provinceName === "" && regionName === "") {
                this.cityOption = []
              } else {
                this.cityOption = data.data;
              }
              }
            }
          } catch (e) {
            console.log(e);
          }
        });
    },
    AddLocation()
    {
      if (this.disableAllFields)
      {
        return;
      }

      // Get the values of the input fields
      const regionValue = this.RegionModel;
      const provinceValue = this.ProvinceModel;
      const cityValue = this.CityModel;
      if (regionValue === '' || regionValue === null) {
        return;
      }

      var valueValid = true;

      const table = document.getElementById('entriesTable').getElementsByTagName('tbody')[0];
      //validate values
      const rows = table.getElementsByTagName('tr');
      for (let i = 0; i < rows.length; i++)
      {
        const cells = rows[i].getElementsByTagName('td');
        const selectedRegion = cells[0].textContent;
        const selectedProvince = cells[1].textContent;
        const selectedCity = cells[2].textContent;

        if ((selectedRegion == regionValue) && (selectedProvince != '') && (selectedProvince != provinceValue))
        {
          valueValid = true;
          if (provinceValue == '') {
            valueValid = false;
            this.message = {
              message: "Location Already Selected",
              type: "danger",
            };
          }
        } else if ((selectedRegion == regionValue) && (selectedProvince == '')) {
          valueValid = false
          this.message = {
              message: "Location Already Selected",
              type: "danger",
            };
        } else if ((selectedRegion == regionValue) && (selectedProvince == provinceValue)) {
          if ((selectedCity != cityValue) && (selectedCity != '') && (cityValue != '')) {
            valueValid = true;
          }else{
            valueValid = false;
            this.message = {
                message: "Location Already Selected",
                type: "danger",
              };
          }
        } else {
          valueValid = true;
        }
      }

      if (valueValid)
      {
        // Create a new row and cells
        const newRow = table.insertRow();
        const regionCell = newRow.insertCell(0);
        const provinceCell = newRow.insertCell(1);
        const cityCell = newRow.insertCell(2);
        const actionCell = newRow.insertCell(3);

        // Insert values into the cells
        regionCell.textContent = regionValue;
        provinceCell.textContent = provinceValue;
        cityCell.textContent = cityValue;

        // Create and insert delete button
        const deleteButton = document.createElement('button');
        deleteButton.textContent = 'Delete';
        deleteButton.className = 'btn btn-danger';
        deleteButton.disabled = this.disableAllFields;
        const self = this;
        deleteButton.onclick = function ()
        {
          if (self.disableAllFields)
          {
            return;
          }
          table.deleteRow(newRow.rowIndex - 1);
        };
        actionCell.appendChild(deleteButton);
      }

      // Clear the input fields

      this.RegionModel = "";
      this.provinceOption = [];
      this.cityOption = [];
    },
    LoadLocations() {
      this.raffleEventModel.locations.forEach(location => {
        const table = document.getElementById('entriesTable').getElementsByTagName('tbody')[0];
        const newRow = table.insertRow();
        const regionCell = newRow.insertCell(0);
        const provinceCell = newRow.insertCell(1);
        const cityCell = newRow.insertCell(2);
        const actionCell = newRow.insertCell(3);

        // Insert values into the cells
        regionCell.textContent = location.region;
        provinceCell.textContent = location.province;
        cityCell.textContent = location.city;

        const deleteButton = document.createElement('button');
        deleteButton.textContent = 'Delete';
        deleteButton.className = 'btn btn-danger';
        deleteButton.disabled = this.disableAllFields;
        const self = this;
        deleteButton.onclick = function ()
        {
          if (self.disableAllFields)
          {
            return;
          }
          table.deleteRow(newRow.rowIndex - 1);
        };
        actionCell.appendChild(deleteButton);
      });
      this.updateDeleteLocationButtons();
    },
    ResetTable() {
      const tableBody = document.getElementById('entriesTable').getElementsByTagName('tbody')[0];
      while (tableBody.rows.length > 0) {
        tableBody.deleteRow(0);
      }
    },
    updateDeleteLocationButtons()
    {
      this.$nextTick(() =>
      {
        const table = document.getElementById('entriesTable');
        if (table)
        {
          const deleteButtons = table.querySelectorAll('button.btn-danger');
          deleteButtons.forEach(button =>
          {
            button.disabled = this.disableAllFields;
          });
        }
      });
    },
    onSearchPromo(searchText)
    {
      if (this.searchTimeout)
      {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(async () => {
        this.promoOptions = [];
        await this.LoadPromo(searchText);
      }, 300);
    },
    async LoadPromo(searchParam) {
      this.isPromoLoading = true;
      await api_loyalty
        .GetPromoBySearch(this.BrandCodeModel, searchParam)
        .then(res => {
          if (res.isSuccess) {
          this.promoOptions = res.data.map(promo => {
               return {
                 id: promo.id,
                 promotion_name: promo.promotion_name,
                 brand_code: promo.brand_code,
                 promotion_type: promo.promotion_type,
               }
            })
          }
        })
        .catch((error) => {
          console.log("Error fetching promotions:", error);
          this.isPromoLoading = false;
      });
    },
    visibilityToggle(raffleType) {
      this.isPromoShow = false;
      this.isDeductionAmountShow = false;
      this.isSkuShow = true;
      
      switch(raffleType) {
        case 'special':
          this.isPromoShow = true;
          this.isDeductionAmountShow = true;
          this.isSkuShow = false;
          break;
        default:
            break
      }
    },
    onEventImageChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var reader = new FileReader();

      reader.onload = (e) => {
        this.is_loads3presigned = true;
        this.uploadEventImageModel.imageFile = files[0];
        this.uploadEventImageModel.image_url = e.target.result;
        let filenameIdentifier = this.raffleEventModel.id;
        if(!filenameIdentifier){
          filenameIdentifier = "id" + Math.random().toString(16).slice(2);
        }
        let filename = this.raffleEventModel.raffleName.replace(/[^A-Z0-9]/ig, "_") + "_event_" + filenameIdentifier;
        api_loyalty
          .GenerateS3PresignedUploadUrl(
            "raffle-event-images",
            files[0],
            filename,
            this.BrandCodeModel
          )
          .then((data) => {
            try {
              if(data.isSuccess)
              {
                this.uploadEventImageModel.imagePresignedUrl = data.data.s3Object.uploadUrl;
                this.raffleEventModel.eventDetailImageUrl = data.data.s3Object.cdnUrl;
              }
            } catch (e) {
              console.log(e);
            }
            this.is_loads3presigned = false;
          });
      };
      reader.readAsDataURL(files[0]);
    },
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
    Multiselect,
  },
  watch: {
    BrandCode: function ()
    {
      this.onRefreshData(this.BrandCode);
    },
    BrandCodeModel: function ()
    {
      this.RegionModel = "";
      this.ProvinceModel = "";
      this.CityModel = "";
      this.fetchData(this.BrandCodeModel, this.RegionModel, this.ProvinceModel, "Region");
      this.onLoadPrize(this.BrandCodeModel);
      this.onRefreshData(this.BrandCodeModel);
    },
    RegionModel: function ()
    {
      this.ProvinceModel = "";
      this.CityModel = "";
      this.fetchData(this.BrandCodeModel, this.RegionModel, this.ProvinceModel, "Province");
    },
    ProvinceModel: function ()
    {
      this.CityModel = "";
      this.fetchData(this.BrandCodeModel, this.RegionModel, this.ProvinceModel, "City");
    },
    RaffleEventTypeModel: async function ()
    {
      this.visibilityToggle(this.RaffleEventTypeModel);
      if (this.RaffleEventTypeModel !== 'special') {
        this.PromoModel = "";
        this.raffleEventModel.deductionAmount = 0;
        this.promoOptions = [];
      }
      else {
        await this.LoadPromo("");
      }
    },

  },

  computed: {
    disableAllFields: function ()
    {
      if (!this.isOnEditRow)
      {
        return false;
      }

      let isRaffleDurationValid = this.startEndDate.every(item => item != null);
      if (isRaffleDurationValid && this.startEndDate.length >= 2)
      {
        let momNow = this.$moment(new Date().toUTCString());
        let currentDate = momNow.format("YYYY-MM-DD");
        let momStart = this.$moment(this.startEndDate[0]).format("YYYY-MM-DD");
        let momEnd = this.$moment(this.startEndDate[1]).format("YYYY-MM-DD");

        if (currentDate >= momStart && currentDate <= momEnd)
        {
          return true;
        }
      }
      return false;
    },
    disableButtonSubmit: function ()
    {
      if (this.disableAllFields)
      {
        return true;
      }
      let isDisabled = true;
      let promoRequired = this.RaffleEventTypeModel === 'special';
      let promoValid = promoRequired ? this.PromoModel != "" : true;

      ////check startenddate value by item value, because startenddate is array, e.g. startenddate :[null, null]
      let isRaffleDurationValid = this.startEndDate.every(item => item != null);      

      // Only check date range for edit mode, not create mode
      if (this.isOnEditRow && isRaffleDurationValid)
      {
        let momNow = this.$moment(new Date().toUTCString());
        let currentDate = momNow.format("YYYY-MM-DD");
        let momStart = this.$moment(this.startEndDate[0]).format("YYYY-MM-DD");
        let momEnd = this.$moment(this.startEndDate[1]).format("YYYY-MM-DD");

        // If current date is between start and end date, disable button (only in edit mode)
        if (currentDate >= momStart && currentDate <= momEnd)
        {
          return true;
        }
      }
      if (this.raffleEventModel.raffleName != "" &&
        this.BrandCodeModel != "" && this.raffleEventModel.winners != 0 &&
        isRaffleDurationValid && promoValid && this.RaffleEventTypeModel != "" &&
        this.MajorPrizeValue != "" && this.raffleEventModel.raffleDate)  
      {
        isDisabled = false;
      }
      return isDisabled;
    },
  }
};
</script>
<style>
.table {
  margin: 10px 20px;
}

.table thead th,
.table tbody tr {
  text-align: center;
}
</style>
